module.exports = __webpack_public_path__ + "img/GUN_BLUR.c4a644f7.jpg";